"use client";
import Header from "@/components/common/header";
import Footer from "@/components/common/footer";
import PreFooter from "@/components/common/preFooter";
import { FormModal } from "@/components/common";
import useModal from "@/hooks/useModal";
import { useState } from "react";

export default function BlogLayout({
  children,
}: {
  children: React.ReactNode;
}) {

  const modal = useModal();
  const [modalTitle, setModalTitle] = useState("Get the Growth Kit");
  const handleModalOpen = (modalTitle?: string) => {
    if (modalTitle) {
      setModalTitle(modalTitle);
    }
    modal.openModal();
  };
  return (
    <>
      <Header />
      <div className="blog-layout">
        <div className="container custom-container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <main className="blog-main-content">
                {children}
              </main>
            </div>
          </div>
        </div>
      </div>
      <PreFooter
        title={"Ready to turn vision into action?"}
        description={"Collaborate with our experts to define clear goals and build actionable strategies for success."}
        onModalOpen={handleModalOpen}
      />
      <Footer />


      {/* Form Modal */}
      <FormModal
        isOpen={modal.isOpen}
        onClose={modal.closeModal}
        onSubmit={() => {
          modal.closeModal();
        }}
        title={modalTitle}
        submitButtonText="Download"
        dialogSlug={modalTitle}
      />
    </>
  );
}
